import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0030',
    ecrans: ['00-2'],
    params: ['?intcleint']
});
